import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from '@services/refreshToken.service';

export const paymentMethodApi = createApi({
  reducerPath: 'paymentMethodApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['payment-method'],
  endpoints: (builder) => ({
    sendGettingPaymentMethod: builder.query({
      query: (customerID: string | number) => {
        return {
          url: `payment/gateway/methods/${customerID}`,
          method: 'GET',
        };
      },
      providesTags: ['payment-method'],
    }),
  }),
});

export const { useSendGettingPaymentMethodQuery } = paymentMethodApi;
